import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'

export const AdsDetails = styled.ul<{ $withColumn?: boolean }>`
  list-style: none;
  padding: 0;

  ${({ $withColumn }) =>
    $withColumn &&
    css`
      @media ${mq(sizes.tablet)} {
        //column-count: 2;
        //column-gap: 3rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 3rem;
        column-row: 1rem;
      }
    `};

  ${({ $withColumn }) =>
    !$withColumn &&
    css`
      display: flex;
      flex-direction: column;
      gap: 2rem;
    `};
`

export const AdsDetailsItem = styled.li<{ $withColumn?: boolean }>`
  display: flex;

  ${({ $withColumn }) =>
    $withColumn &&
    css`
      justify-content: space-between;
      align-items: start;
      gap: 2rem;
      margin-bottom: 1rem;
    `};

  ${({ $withColumn }) =>
    !$withColumn &&
    css`
      flex-direction: column;
      gap: 1rem;
      ${ValueContainer} {
        text-align: left;
      }
    `};
`

export const Label = styled.span`
  ${({ theme }) => theme.textStyles.firaSansTextBaseSemiBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  min-width: 15rem;

  @media ${mq(null, sizes.tablet)} {
    flex: 1;
  }
`

export const ValueContainer = styled.div`
  ${({ theme }) => theme.textStyles.firaSansTextBase};

  @media ${mq(null, sizes.tablet)} {
    flex: 1;
    text-align: right;
  }
`

export const Value = styled.span``
